import { useEffect, useState } from "react";
import Auth from "../Auth";
import { useSudowriteStore } from "../stores/sudowriteStore";

// Advisory UI only: the server rechecks cohort, time and admission on every
// request. Never extend access from a cached status after its exact end.
export default function useNovelNovemberSprint() {
  const subscription = useSudowriteStore(state => state.subscription);
  const uid = subscription?.userId;
  const eligible = subscription?.features?.novelNovember2026 === true;
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let disposed = false;
    let refreshSequence = 0;
    let expiry;
    setStatus(null);
    if (!eligible || !uid) return;
    const refresh = async () => {
      const sequence = ++refreshSequence;
      const startedAt = Date.now();
      try {
        const result = await Auth.fetchWithIdToken("/api/novel-november/status", {});
        if (!disposed && sequence === refreshSequence) {
          clearTimeout(expiry);
          const remaining = Date.parse(result.active?.end) - result.now - (Date.now() - startedAt);
          setStatus({ ...result, uid, checkedAt: startedAt });
          if (remaining > 0) expiry = setTimeout(() => setStatus(null), remaining);
        }
      } catch { if (!disposed && sequence === refreshSequence) setStatus(null); }
    };
    void refresh();
    const poll = setInterval(refresh, 15000);
    window.addEventListener("focus", refresh);
    return () => { disposed = true; clearInterval(poll); clearTimeout(expiry); window.removeEventListener("focus", refresh); };
  }, [uid, eligible]);
  const serverNow = status ? status.now + Math.max(0, Date.now() - status.checkedAt) : Infinity;
  const active = eligible && status?.uid === uid && status?.eligible && status.active && serverNow < Date.parse(status.active.end);
  return { active: !!active, window: active ? status.active : null,
    writeAvailable: !!active && status.tools?.write === true, draftAvailable: !!active && status.tools?.draft === true };
}
